import { MARBLE_STATES, type MarbleState } from "@marble/core/modules/states";
import { State } from "@prisma/client";

// MARBLE_STATES / MarbleState live in @marble/core because a cron needs them
// too. Re-exported here so existing app call sites keep one import.
export { MARBLE_STATES, type MarbleState };

// Sentinel value for StateDropdown's "Another state" option.
// Not a real State enum value — forms holding it must block submission.
export const ANOTHER_STATE_OPTION = "ANOTHER_STATE" as const;

export const StateToColor: Record<MarbleState, string> = {
  [State.NY]: "bg-blue-200 border-blue-300",
  [State.NJ]: "bg-purple-200 border-purple-300",
  [State.OH]: "bg-red-200 border-red-300 bg-opacity-50",
  [State.AZ]: "bg-orange-200 border-orange-300",
};

export const getMarbleStateColor = (state: State): string | undefined =>
  StateToColor[state as MarbleState];

/**
 * True when the student lives in a state Marble currently serves.
 * Empty / unset values are not serviced-or-not — they just mean no pick yet.
 */
export function isMarbleServicedState(
  state: string | null | undefined,
): state is MarbleState {
  if (!state) {
    return false;
  }
  return (MARBLE_STATES as readonly string[]).includes(state);
}

/**
 * True when the referral form should warn (and block submit) because the
 * residential state is a real pick Marble does not serve — "Another state"
 * or a non-Marble state from sibling prefill. Does not fire for an empty
 * dropdown; Radix also emits "" when the current value is briefly missing
 * from the option list, and that must not look like "we don't serve here."
 */
export function isStudentStateNotServiced(
  state: string | null | undefined,
): boolean {
  return Boolean(state) && !isMarbleServicedState(state);
}
